import { h, Component } from 'preact';
import s from 'components/bolt/expandableTextList/question.sss';
import { joinClasses } from 'utils/utils';
import { onMarkdownClick } from 'utils/bolt';
import HTML from 'components/core/html/html.js';

export default class Question extends Component {
	constructor(props) {
		super(props);

		this.answerRef = this.answerRef.bind(this);
		this.onClick = this.onClick.bind(this);
	}

	componentWillUpdate(nextProps) {
		if (!!nextProps.isOpen !== !!this.props.isOpen) {
			let $el = this.$answer;
			if ($el.base) $el = $el.base;
			if (nextProps.isOpen) {
				this.base.classList.add(s.open);
				$el.style.height = 'auto';
				let height = $el.clientHeight;
				$el.style.height = '0';
				$el.clientWidth;
				$el.style.height = height + 'px';
				// setTimeout(() => $el.style.height = '', 500);
				$el.addEventListener('transitionend', () => ($el.style.height = ''), { once: true });
			} else {
				$el.style.height = $el.clientHeight + 'px';
				this.base.classList.remove(s.open);
				$el.clientWidth;
				$el.style.height = '';
			}
		}
	}

	answerRef(ref) {
		this.$answer = ref;
	}

	onClick(e) {
		onMarkdownClick(e);
	}

	renderQuestionText() {
		return this.props.question;
	}

	renderQuestion() {
		return (
			<button class={joinClasses(s.title, 'large')} onClick={this.props.toggleActive}>
				{this.renderQuestionText()}
				<div class={s.icon} />
			</button>
		);
	}

	renderAnswer() {
		const content = this.props.answer;
		if (typeof content !== 'string') {
			return (
				<div class={s.content} ref={this.answerRef}>
					{content}
				</div>
			);
		}
		return <HTML class={s.content} content={this.props.answer} markdown ref={this.answerRef} onClickCapture={this.onClick} />;
	}

	render(props) {
		const { isOpen } = props;

		// Note: should use <details> and <summary>
		//   will just need a bit of extra CSS once more widely supported:
		//     .section::details-content { transition: content-visibility .3s allow-discrete }
		return (
			<div class={joinClasses(s.section, isOpen && s.open)}>
				{this.renderQuestion()}
				{this.renderAnswer()}
			</div>
		);
	}
}
